import { gql } from '@apollo/client'

export const tableCellBorderFragment = gql`
    fragment tableCellBorderFragment on Border {
        color {
            r
            g
            b
            a
        }
        distanceFromText
        lineStyle
        lineWidth
        shadow
    }
`

export const tableCellFormatFragment = gql`
    fragment tableCellFormatFragment on CellFormat {
        bottomBorder {
            ...tableCellBorderFragment
        }
        topBorder {
            ...tableCellBorderFragment
        }
        leftBorder {
            ...tableCellBorderFragment
        }
        rightBorder {
            ...tableCellBorderFragment
        }
        preferredWidthType
        widthValue
    }
    ${tableCellBorderFragment}
`

export const tableContentFragment = gql`
    fragment tableContentFragment on TableContent {
        alignment
        cellFormat {
            ...tableCellFormatFragment
        }
        cellPoints
        columnNumber
        content
        columnNumberStart
        columnNumberEnd
        isMergedCell
        rowNumber
        textContentElements {
            id
            type
            text
            metricUnits
            imperialUnits
            elements {
                text
                metricUnits
                imperialUnits
                elements {
                    metricUnits
                    imperialUnits
                }
            }
        }
    }
    ${tableCellFormatFragment}
`

export const tableListContentFragment = gql`
    fragment tableListContentFragment on TableDataContent {
        alignment
        cellFormat {
            ...tableCellFormatFragment
        }
        cellPoints
        columnNumber
        content
        columnNumberStart
        columnNumberEnd
        isMergedCell
        rowNumber
        textContentElements {
            id
            type
            text
            metricUnits
            imperialUnits
            elements {
                text
                metricUnits
                imperialUnits
                elements {
                    metricUnits
                    imperialUnits
                }
            }
        }
    }
    ${tableCellFormatFragment}
`

export const tableListFragment = gql`
    fragment tableListFragment on TableData {
        id
        tableIdentifier
        totalColumns
        totalRows
        tableHeader {
            ...tableListContentFragment
        }
        content {
            ...tableListContentFragment
        }
    }
    ${tableListContentFragment}
`

export const tableInfoFragment = gql`
    fragment tableInfoFragment on TableInfo {
        id
        tableIdentifier
        totalColumns
        totalRows
        tableHeader {
            ...tableContentFragment
        }
        content {
            ...tableContentFragment
        }
    }
    ${tableContentFragment}
`
